var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23081_67048)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.99 0H0.00996094C0.00445966 0 0 0.00445966 0 0.00996094V33.99C0 33.9955 0.00445966 34 0.00996094 34H33.99C33.9955 34 34 33.9955 34 33.99V0.00996094C34 0.00445966 33.9955 0 33.99 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7375 14.2781C14.1686 14.056 12.5694 14.3189 11.1542 15.0315C9.73897 15.7441 8.57548 16.8724 7.8197 18.265C7.06393 19.6577 6.75201 21.2481 6.92577 22.823C7.09953 24.3979 7.75066 25.8821 8.79185 27.0764C9.83305 28.2708 11.2145 29.1183 12.751 29.5052C14.2875 29.8922 15.9056 29.8001 17.3883 29.2414C18.871 28.6826 20.1474 27.6839 21.0464 26.3791C21.9454 25.0743 22.4239 23.5259 22.4179 21.9414V13.4414C24.1218 14.6603 26.1667 15.3109 28.2617 15.3008V11.1172C26.7118 11.1172 25.2254 10.5015 24.1295 9.40559C23.0336 8.30968 22.4179 6.8233 22.4179 5.27344H18.1945V21.9813C18.193 22.7311 17.9542 23.4613 17.5125 24.0672C17.0707 24.6731 16.4485 25.1237 15.735 25.3544C15.0216 25.5852 14.2534 25.5843 13.5405 25.3518C12.8275 25.1194 12.2064 24.6673 11.7661 24.0603C11.3258 23.4534 11.0888 22.7227 11.089 21.9728C11.0893 21.223 11.3268 20.4924 11.7676 19.8858C12.2084 19.2791 12.8298 18.8275 13.5429 18.5956C14.256 18.3636 15.0241 18.3633 15.7375 18.5945V14.2781Z",
    fill: "#FF004F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5421 13.282C12.9733 13.0599 11.374 13.3228 9.95885 14.0354C8.54365 14.748 7.38016 15.8763 6.62439 17.2689C5.86862 18.6616 5.5567 20.252 5.73046 21.8269C5.90422 23.4018 6.55535 24.886 7.59654 26.0803C8.63773 27.2747 10.0192 28.1222 11.5557 28.5091C13.0922 28.8961 14.7103 28.804 16.193 28.2453C17.6757 27.6865 18.9521 26.6878 19.8511 25.383C20.7501 24.0782 21.2286 22.5298 21.2226 20.9453V12.4453C22.9265 13.6642 24.9714 14.3149 27.0664 14.3047V10.1211C25.5165 10.1211 24.0301 9.50541 22.9342 8.4095C21.8383 7.31358 21.2226 5.8272 21.2226 4.27734H16.9992V20.9852C16.9977 21.735 16.7589 22.4652 16.3171 23.0711C15.8754 23.677 15.2532 24.1276 14.5397 24.3583C13.8263 24.5891 13.0581 24.5882 12.3451 24.3557C11.6322 24.1233 11.0111 23.6712 10.5708 23.0643C10.1304 22.4573 9.89344 21.7266 9.89371 20.9767C9.89398 20.2269 10.1315 19.4963 10.5723 18.8897C11.013 18.283 11.6345 17.8314 12.3475 17.5995C13.0606 17.3675 13.8288 17.3672 14.5421 17.5984V13.282Z",
    fill: "#00F2EA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23081_67048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokLogo);
export default __webpack_public_path__ + "static/media/tiktokLogo.cc648f44f0600a9e6ebb25fc62f04e13.svg";
export { ForwardRef as ReactComponent };